import { QuoteReservation } from '@/models/quote'

const SEAT_KEYS = ['beds', 'chairs', 'deckChairs', 'maxiBeds'] as const

export function getReservationSeatsAmount(
  reservation: Pick<
    QuoteReservation,
    'beds' | 'chairs' | 'deckChairs' | 'maxiBeds'
  >
): number {
  return SEAT_KEYS.reduce(
    (sum, key) => sum + (Number(reservation[key]) || 0),
    0
  )
}

export function sumReservationsSeatsAmount(
  reservations: Array<
    Pick<QuoteReservation, 'beds' | 'chairs' | 'deckChairs' | 'maxiBeds'>
  >
): number {
  return reservations.reduce(
    (sum, reservation) => sum + getReservationSeatsAmount(reservation),
    0
  )
}
